import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const ReportBuilderWizardRoute: RouteType = {
  name: "ReportBuilderWizard",
  path: "/workflows/report-builder",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Custom Report Builder",
      component: () => import("./ReportBuilderWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./ReportBuilderWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const apiServicesStore = rootStore.apiServicesStore as ServiceStore;
      const bidAnalyticsStore = rootStore.bidAnalyticsStore as ServiceStore;
      const financialReportsStore = rootStore.financialReportsStore as ServiceStore;

      await Promise.all([
        apiServicesStore?.find(),
        bidAnalyticsStore?.find(),
        financialReportsStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for report builder:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).reportBuilderWizardStore;
    store?.reset();
  },
};

export default ReportBuilderWizardRoute;